import { NumberFormatRuLocale } from 'Helpers'

export const onlyDigits = (value): string => value && (value || '').replace(/\D+/g, '')

export const trimValue = (value = '') => value.trim()

export const getInitials = (str: string, count = 2, removeRoundBrackets = true) => {
	if (!str) return ''
	const roundBrRegex = /\([^)]*\)/g
	const processedStr = removeRoundBrackets ? str.replace(roundBrRegex, '') : str
	const words = processedStr.trim().split(/\s+/)
	if (words.length === 0) return ''

	const [lastName, ...rest] = words

	const selectedWords = [lastName, ...rest.slice(0, count)]

	const initials = selectedWords.map((word, index) =>
		index === 0 ? word : `${word.charAt(0).toUpperCase()}.`
	)
	return initials.join(' ')
}

export const getArrayInitialValue = (strParams: string | string[] | number | number[]): any[] => {
	if (!strParams) return undefined
	if (typeof strParams === 'number') return [strParams]
	if (Array.isArray(strParams)) return strParams
	return strParams?.split(',').map((p: string): number | string => {
		if (Number.isNaN(+p)) return p
		return +p
	})
}

export const getMaskPhone = (s: string): string => {
	return s?.length >= 12
		? `${s[0]}${s[1]} (${s[2]}${s[3]}${s[4]}) ${s[5]}${s[6]}${s[7]}-${s[8]}${s[9]}-${s[10]}${s[11]}`
		: ''
}

export const sliceText = (text: string, count: number): string => {
	const ENDING = ' ...'
	if (!text || !text.length) return ''
	if (text.length <= count) return text
	return `${text.slice(0, count - ENDING.length)}${ENDING}`
}

export const getOnlyInitials = (first_name: string, last_name: string): string => {
	const notFirstName = !first_name || !first_name.length
	const notLastName = !last_name || !last_name.length

	if (notFirstName && notLastName) return '?'
	return `${first_name?.[0] || ''}${last_name?.[0] || ''}`.toUpperCase()
}

export const getClosedUserPhone = (phone: string): string => {
	const CLOSE_POSITIONS = [2, 3, 4, 5, 6, 7]
	const SPACED_INDEXS = [2, 5]
	const DELIMITER_INDEXS = [8, 10]
	const phoneArr = (phone || '').split('')
	const result = []
	phoneArr.forEach((l: string, i: number): void => {
		if (CLOSE_POSITIONS.find((item): boolean => item === i)) {
			result.push('*')
		} else {
			result.push(l)
		}
		if (DELIMITER_INDEXS.find((item): boolean => item === i + 1)) {
			result.push('-')
		}
		if (SPACED_INDEXS.find((item): boolean => item === i + 1)) {
			result.push(' ')
		}
	})

	return result.join('')
}

const getNumEnding = (words: string[]) => (count: number) => {
	const rem = Math.abs(count) % 100
	if (rem >= 11 && rem <= 19) return words[2]
	switch (rem % 10) {
		case 1:
			return words[0]
		case 2:
		case 3:
		case 4:
			return words[1]
		default:
			return words[2]
	}
}

export const daysLabel = getNumEnding(['день', 'дня', 'дней'])
export const yearsLabel = getNumEnding(['год', 'года', 'лет'])
export const filesLabel = getNumEnding(['файла', 'файлов', 'файлов'])
export const recordLabel = getNumEnding(['запись', 'записи', 'записей'])

export const clearSpecialCharacters = (value = '') =>
	value ? value.replace(/\n|<|>|<\/|\/>/g, '') : value

export const trimText = (value = '') => value?.toString()?.trim().replace(/\s\s+/g, ' ')

export const thousandSeparatorAdd = (value?: string) => {
	if (value) {
		const d = onlyDigits(value)
		return d ? NumberFormatRuLocale(+d) : d
	}
	return value
}

export const getNameEmail = (str: string): { name: string; email: string } => {
	if (!str) return { name: '', email: '' }
	const strArray = str.split(' ')
	const nameOnly = []
	const emailOnly = []

	for (let i = 0; i < strArray.length; i += 1) {
		if (strArray[i].includes('@')) {
			emailOnly.push(strArray[i])
		} else {
			nameOnly.push(strArray[i])
		}
	}
	return {
		name: nameOnly.join(' '),
		email: emailOnly.join(' ').slice(1, -1),
	}
}

export const divideInputData = (current, missingKeys): { show: []; hidden: [] } => {
	return current.reduce(
		(prev, next) => {
			const is = missingKeys.find((missingKey) => String(next) === String(missingKey))

			if (is) prev.hidden.push(next)
			else prev.show.push(next)

			return prev
		},
		{ show: [], hidden: [] }
	)
}

export const daysMoreLabel = (count: number): string => {
	const penult = +String(count).split('').slice(0, -1).pop()
	if (count % 10 === 1 && penult !== 1) return 'дня'
	return 'дней'
}
